export default {
  // detail list
  'dict.detail.title': 'Dictionary details',
  'dict.detail.query.dictKey': 'Dictionary key',
  'dict.detail.query.dictKey.placeholder': 'Enter dictionary key',
  'dict.detail.column.dictLabel': 'Label',
  'dict.detail.column.dictValue': 'Value',
  'dict.detail.column.sortNum': 'Sort',
  'dict.detail.column.status': 'Status',
  'dict.detail.column.status.normal': 'Normal',
  'dict.detail.column.status.disable': 'Disable',
  'dict.detail.column.remark': 'Remark',
  'dict.detail.confirm.delete.title': 'Are you sure you want to delete the dictionary "{dictLabel}"?',
  'dict.detail.confirm.delete.batch.title': 'Are you sure you want to delete the selected {length} dictionaries?',
  // detail edit
  'dict.detail.edit.title': 'Modify dictionary',
  'dict.detail.add.title': 'Add dictionary',
  'dict.detail.edit.form.dictLabel': 'Dictionary label',
  'dict.detail.edit.form.dictLabel.placeholder': 'Please enter the dictionary label',
  'dict.detail.edit.form.dictLabel.required': 'Please enter the dictionary label',
  'dict.detail.edit.form.dictValue': 'Dictionary value',
  'dict.detail.edit.form.dictValue.placeholder': 'Please enter the dictionary value',
  'dict.detail.edit.form.dictValue.required': 'Please enter the dictionary value',
  'dict.detail.edit.form.sortNum': 'Sort',
  'dict.detail.edit.form.sortNum.required': 'Please enter the dictionary sort',
  'dict.detail.edit.form.status': 'Status',
  'dict.detail.edit.form.status.normal': 'Normal',
  'dict.detail.edit.form.status.disable': 'Disable',
  'dict.detail.edit.form.status.required': 'Please select the dictionary status',
  'dict.detail.edit.form.remark': 'Remark',
  'dict.detail.edit.form.remark.placeholder': 'Please enter a remark',
  // list
  'dict.query.dictKey': 'Dictionary key',
  'dict.query.dictKey.placeholder': 'Enter dictionary key',
  'dict.column.dictKey': 'Dictionary key',
  'dict.column.remark': 'Remark',
  'dict.column.status': 'Status',
  'dict.column.status.normal': 'Normal',
  'dict.column.status.disable': 'Disable',
  'dict.column.operation.detail': 'Details',
  'dict.confirm.delete.batch.title': 'Are you sure you want to delete the selected {length} dictionaries?',
  'dict.confirm.delete.title': 'Are you sure you want to delete the dictionary "{dictKey}"?',
  // edit
  'dict.edit.title': 'Modify dictionary',
  'dict.add.title': 'Add dictionary',
  'dict.add.success': 'Added successfully',
  'dict.edit.success': 'Modified successfully',
  'dict.edit.form.dictKey': 'Dictionary key',
  'dict.edit.form.dictKey.placeholder': 'Please enter the dictionary key',
  'dict.edit.form.dictKey.required': 'Please enter the dictionary key',
  'dict.edit.form.status': 'Status',
  'dict.edit.form.status.normal': 'Normal',
  'dict.edit.form.status.disable': 'Disable',
  'dict.edit.form.status.required': 'Please select the dictionary status',
  'dict.edit.form.remark': 'Remark',
  'dict.edit.form.remark.placeholder': 'Please enter a remark',
}
